// extracted by mini-css-extract-plugin
module.exports = {"table":"Report_table__3qGj6","row":"Report_row__fqscD","rowHead":"Report_rowHead__r3o_z","title":"Report_title__23XVp"};